import {
  FETCH_ALERT_RETRY_HISTORY_LIST,
  FETCH_ALERT_RETRY_HISTORY_LIST_SUCCESS,
  FETCH_ALERT_RETRY_HISTORY_LIST_FAIL
} from '../../actions/cm/alertList';
export const initialState = {
  isLoading: false,
  list: [],
  total: 0,
  hasError: false,
  filters: {
    status: null,
    searchField: '',
    searchText: '',
    isLatest: null
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_ALERT_RETRY_HISTORY_LIST:
      return {
        ...state,
        list: [],
        isLoading: true,
        hasError: false
      };
    case FETCH_ALERT_RETRY_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        list: payload?.retries || [],
        total: payload?.totalCount || 0,
        isLoading: false
      };
    case FETCH_ALERT_RETRY_HISTORY_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };

    default:
      return state;
  }
}
